import { EnrichedVideoEditorEditListItemDto, VideoEditorPublishedPlatformEntryDtoStatus } from '@app/modules/video-editions/types';

export type CompletedPublishedPlatformsSummary = {
  count: number;
  /** Set when exactly one platform has a completed publish (for “Published on YouTube” style copy). */
  singlePlatformKey: string | null;
};

/**
 * Derives completed publish count and optional single platform id from edit list payload.
 */
export function getCompletedPublishedPlatformsSummary(
  publishedPlatforms: EnrichedVideoEditorEditListItemDto['publishedPlatforms'],
): CompletedPublishedPlatformsSummary {
  if (!publishedPlatforms?.length) {
    return { count: 0, singlePlatformKey: null };
  }
  const completed = publishedPlatforms.filter(
    (p) => p.status === VideoEditorPublishedPlatformEntryDtoStatus.COMPLETED,
  );
  const count = completed.length;
  return {
    count,
    singlePlatformKey: count === 1 ? completed[0]!.platform : null,
  };
}
